import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../../core/_BLComponent.jsx';

import ModalFrame 	from '../../common/_ModalFrame.jsx';
import CustomCheckbox 	from '../../common/_CustomCheckbox.jsx';
import BDPSeriesProgressBar from './_BDPSeriesProgressBar.jsx';
import BDPPricingBlock from './_BDPPricingBlock.jsx';

import {bdpDateFormatShort} from './_BDPUtilities.jsx';


export default class BDPPurchasingBlock extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
				showPreorderModal: false
			,	showPaymentShippingModal: false
			, showPreorderModal: false
			, doNotShow: false
		}

	}

	render() {
		const {data, salesInfo, hidePurchase = false} = this.props;

		if(salesInfo && salesInfo.stock) {
			const {dPercentagePreordered, dPercentageFunded, bFunded, bSoldOut} = salesInfo.stock;
			const isSoldOut = salesInfo.stock.bSoldOut || salesInfo.stock.dPercentagePreordered >= 1;

			return (
				<React.Fragment>
					{this.state.showPaymentShippingModal ? this.renderPaymentShippingModal() : null}
					{this.state.showPreorderModal ? this.renderPreorderModal() : null}
					<BDPPricingBlock hidePurchase={hidePurchase} salesInfo={salesInfo}/>
					<BDPSeriesProgressBar progress={dPercentagePreordered} fundedLimit={dPercentageFunded} funded={bFunded} soldOut={bSoldOut}/>
					{!hidePurchase ? 
						isSoldOut ? 
							<div className="btn btn--yellow bdp-purchasing__cta-purchase bdp-purchasing__cta-purchase--sold-out" data-ts-name="bdp-purchasing__pre-order">
								Sold out
							</div>
						: 
							<a href={`https://www.lego.com/cart?product=${salesInfo.sku}`} target="_blank" onClick={(e) => this.triggerPurchase(e)} className="btn btn--yellow bdp-purchasing__cta-purchase text--transform-unset" data-ts-name="bdp-purchasing__pre-order">
								Pre-order on LEGO.com<i className="far fa-external-link-square-alt l-margin-left--sm"/>
							</a>
					: null}

					<a href={blapp.url2.getBDPSubmissionDesignViewUrl(data.idSubmission, data)} className="bdp-purchasing__cta" data-ts-name="bdp-purchasing__view-details">
						View details<i className="far fa-long-arrow-right l-margin-left--sm"/>
					</a>
					<div className="bdp-purchasing__modal-cta">
						<button className="btn btn--link text--medium" onClick={() => this.togglePaymentShippingInfo()}>Payment and shipping<i className="far fa-question-circle l-margin-left--sm"/></button>
					</div>
				</React.Fragment>
			);
		}else{
			return (
				<React.Fragment>
					{this.state.showPaymentShippingModal ? this.renderPaymentShippingModal() : null}
					{this.state.showPreorderModal ? this.renderPreorderModal() : null}
					<BDPPricingBlock hidePurchase={hidePurchase} salesInfo={salesInfo}/>
					<a href={blapp.url2.getBDPSubmissionDesignViewUrl(data.idSubmission, data)} className="bdp-purchasing__cta" data-ts-name="bdp-purchasing__view-details">
						View details<i className="far fa-long-arrow-right l-margin-left--sm"/>
					</a>
				</React.Fragment>
			);
		}
	}

	triggerPurchase(e) {
		if(blapp.session.isLoggedIn()) { 
			if(blapp.cookie.getLocalStorage('doNotShowLEGORedirect') == 'true') {
				this.trackClick(this.props.salesInfo.sku);
				return null;
			}else{
				e.preventDefault();

				this.togglePreorderModal();
			}
		}else{
			e.preventDefault();
			
			blapp.refs.get( "header" ).showLogin(() => {
				if(blapp.session.isLoggedIn()) {
					this.triggerPurchase();
				}
			});
		}
	}

	togglePreorderModal() {
		this.setState({showPreorderModal: !this.state.showPreorderModal});
		blapp.screen.toggleScroll(!this.state.showPreorderModal);
	}

	togglePaymentShippingInfo() {
		this.setState({showPaymentShippingModal: !this.state.showPaymentShippingModal});
		blapp.screen.toggleScroll(!this.state.showPaymentShippingModal);
	}

	renderPaymentShippingModal() {
		return (
			<ModalFrame classes="modal--medium bdp-submission-payment-shipping-modal" closeFunc={() => this.togglePaymentShippingInfo()}>
				<div className="l-pad l-pad-top--sm">
					<header className="l-flex l-split l-margin-bottom">
						<h1 className="text--title text--bold">Payment and Shipping Info</h1>
						<button className="text--title text--bold l-margin-left l-cursor-pointer" onClick={() => this.togglePaymentShippingInfo()}><i className="fas fa-times"/></button>
					</header>
					<div className="l-margin-bottom">
						<p className="l-margin-bottom">You will only be charged if this project is crowdfunded (receives at least 3,000 pre-orders) and once the product is shipped to you.</p>
						<p className="l-margin-bottom">Note that your credit card provider will temporarily hold the amount needed to pay for your entire order, called a payment authorization, which is a temporary hold of funds that lasts from several days up to one month. You can read more about that <a href="https://www.lego.com/en-us/service/help/online_shop/online_shop/all-about-payment-authorizations-kA009000001Jz6nCAC" target="_blank">here</a>.</p>
						<p className="l-margin-bottom">We estimate the product will ship in {bdpDateFormatShort(this.props.data.dmBDPSeries.udtProductionStart)}. For shipping prices, please <a href={blapp.url2.getCrowdProjectFAQUrl() + '#how-much-will-shipping-cost'}>read our FAQ</a> to review your regional pricing options.</p>
						<p className="l-margin-bottom">Please note that <a href="https://www.lego.com">lego.com</a> will not ship to Post Office Boxes (PO Boxes) or mail forwarding addresses.</p>
						<p className="l-margin-bottom">We will send out an email before we ship the set and charge your card. Please make sure that the card you originally entered when you pre-ordered this project has not expired. You may go to <a href="https://www.lego.com">lego.com</a> to update your payment method. </p>
						<p>If you pay for your order using PayPal, note that you won't be able to update your shipping address at a later date. If your address changes, you'll need to contact LEGO Customer Service for assistance.</p>
					</div>
					<div className="bdp-payment-shipping-modal__footer">
						<button className="btn btn--cta text--bold btn--wide bdp-payment-shipping-modal__footer-btn" onClick={() => this.togglePaymentShippingInfo()}>Done</button>
					</div>
				</div>
			</ModalFrame>
		);
	}

	renderPreorderModal() {
		return (
			<ModalFrame classes="modal--medium bdp-submission-preorder-modal" closeFunc={() => this.togglePreorderModal()}>
				<div className="l-pad l-pad-top--sm l-relative">
					<button className="modal__fixed-close text--title text--bold l-margin-left l-cursor-pointer" onClick={() => this.togglePreorderModal()}><i className="fas fa-times"/></button>
					<header className="bdp-submission-preorder-modal__header">
						<div className="bdp-submission-preorder-modal__header-img">
							<img src={`//${blapp.config.getHost( "static2" )}/img/lego_logo.png`} alt="LEGO&reg;"/>
						</div>
						<h1 className="text--title text--bold">You will be redirected to LEGO.com to place your pre-order(s).</h1>
					</header>
					<div className="bdp-submission-preorder-modal__content-container">
						<ul className="bullet-list">
							<li>Log in with your LEGO ID, or check out as a guest.</li>
							<li>There is a limit of 2 per household per project.</li>
							<li>Orders will earn Insiders Points</li>
							<li>You can use your Insider points for a discount.</li>
							<li>BDP orders do not qualify for LEGO Shop Gift with Purchase.</li>
							<li>BDP orders do not qualify for LEGO Shop Insiders Rewards redemptions.</li>
						</ul>
					</div>
					<p className="text--small-title"><strong>If you want to order another BDP {this.props.data.dmBDPSeries.strName} set, you will need to go back to bricklink.com.</strong></p>
					<div className="bdp-submission-preorder-modal__footer">
						<a className="btn bdp-submission-preorder-modal__continue" target="_blank" href={`https://www.lego.com/cart?product=${this.props.salesInfo.sku}`} onClick={() => this.trackClick(this.props.salesInfo.sku)}>Continue to LEGO.com<i className="far fa-external-link-square-alt l-margin-left--sm"/></a>
						<button className="btn bdp-submission-preorder-modal__cancel" onClick={() => this.togglePreorderModal()}>Cancel</button>
						<label className="bdp-submission-preorder-modal__dont-show">
							<CustomCheckbox isDark classes="l-margin-right--sm" isChecked={this.state.doNotShow} onChangeFunc={() => this.doNotShow()}/>
							Don't show again
						</label>
					</div>
				</div>
			</ModalFrame>
		);
	}

	trackClick(sku) {
		_paq.push(['trackEvent', 'BDP', 'Trigger Purchase', `S${this.props.data.dmBDPSeries.idSeries} - ${this.props.data.strSubmissionName}`]);
		blapp.track.trackGeneral(10100, sku, blapp.session.codeCountryDetected);
	}

	doNotShow() {
		this.setState({doNotShow: !this.state.doNotShow}, () => {
			if(this.state.doNotShow) {
				blapp.cookie.setLocalStorage('doNotShowLEGORedirect', true);
			}else{
				blapp.cookie.setLocalStorage('doNotShowLEGORedirect', false);
			}
		});
	}
}